import React from 'react';
import { Handle, Position } from '@xyflow/react';
import { TrashIcon } from '@heroicons/react/24/outline';

const StarNode = ({ data, id }) => {
  // Define color schemes based on source type
  const colorScheme = {
    mfd: {
      border: 'border-yellow-200',
      text: 'text-gray-700',
      handle: 'border-2 border-yellow-700 !bg-yellow-700 hover:!bg-yellow-50',
      bg: 'bg-[#F6971A80]'
    },
    manager: {
      border: 'border-blue-200',
      text: 'text-gray-700',
      handle: 'border-2 border-blue-800 !bg-blue-800 hover:!bg-blue-50',
      bg: 'bg-[color-mix(in_srgb,var(--brand-primary)_20%,transparent)]'
    },
    saleshead: {
      border: 'border-green-200',
      text: 'text-gray-700',
      handle: 'border-2 border-green-800 !bg-green-800 hover:!bg-green-50',
      bg: 'bg-[#19945980]'
    },
    branchhead: {
      border: 'border-red-200',
      text: 'text-gray-700',
      handle: 'border-2 border-red-800 !bg-red-800 hover:!bg-red-50',
      bg: 'bg-[#D6201C80]'
    },
  };

  // Add console.log to debug the type being received
  console.log('Node type:', data.type);
  
  const colors = colorScheme[data.type] || colorScheme.mfd;
  const [isHovered, setIsHovered] = React.useState(false);

  return (
    <div 
      className={`bg-white p-2 rounded-full shadow-lg border-4 ${colors.border} relative`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Delete button */}
      <div 
        className={`absolute -right-2 -top-2 w-5 h-5 bg-gray-200 rounded-full flex items-center justify-center cursor-pointer 
          hover:bg-gray-600 hover:text-white z-10 transition-opacity duration-200 
          ${isHovered ? 'opacity-100' : 'opacity-0'}`}
        onClick={(e) => {
          e.stopPropagation();
          if (data.onDelete) {
            data.onDelete(id);
          }
        }}
      >
        <TrashIcon className='w-4 h-4 p-0.5 hover:text-white text-black'/>
      </div>

      <div className={`flex items-center ${colors.bg} px-2 ${colors.border} rounded-full justify-center w-28 h-28`}>
        <span className={`font-bold text-lg ${colors.text} text-center rounded-lg`}>
          {data.label || data.type}
        </span>
      </div>

      <Handle
        type="target"
        position={Position.Top}
        className={`w-4 h-4 ${colors.handle}`}
      />
    </div>
  );
};

export default StarNode; 